export const AhaMoment = Object.freeze({
	Banner: 'banner',
	TrialBanner: 'trial_banner',
	AddResource: 'add_resource',
	MessageTemplate: 'message_template',
	AddClient: 'add_client',
	ResourceWorkload: 'resource_workload',
	ResourceIntersection: 'resource_intersection',
	ExpandGrid: 'expand_grid',
	SelectResources: 'select_resources',
	CyclePopup: 'cycle_popup',
	SearchNavigation: 'search_navigation',
});
